import { useMemo } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { get } from "lodash"
import PreferenceContext from "hooks/preferences"

function PreferenceContextWrapper(props) {
  const { accountId, WrappedComponent, preferenceKey, preferenceType } = props
  const preferencesProps = useMemo(() => ({ accountId, key: preferenceKey, type: preferenceType }), [accountId, preferenceKey, preferenceType])

  return <PreferenceContext.Provider value={preferencesProps}>
    <WrappedComponent {...props} />
  </PreferenceContext.Provider>
}

PreferenceContextWrapper.propTypes = {
  WrappedComponent: PropTypes.elementType.isRequired,
  accountId: PropTypes.string.isRequired,
  preferenceKey: PropTypes.string.isRequired,
  preferenceType: PropTypes.string.isRequired,
}

function mapStateToProps(preferenceKeyGetter) {
  return (state, props) => ({
    accountId: get(state, "global.selected.accountId"),
    preferenceKey: typeof preferenceKeyGetter === "function" ? preferenceKeyGetter(state, props) : undefined,
  })
}

function withPreferenceContext(WrappedComponent, preferenceType) {
  const WithPreferenceContextWrapper = props => <PreferenceContextWrapper WrappedComponent={WrappedComponent} preferenceType={preferenceType} {...props} />
  WithPreferenceContextWrapper.displayName = `withPreferenceContext(${WrappedComponent.displayName || WrappedComponent.name})`
  return WithPreferenceContextWrapper
}

export default (WrappedComponent, preferenceType, preferenceKeyGetter) => connect(mapStateToProps(preferenceKeyGetter))(withPreferenceContext(WrappedComponent, preferenceType))
